import { HTTPClient } from '@aspendental/shared-utils/http';

export const httpClient: HTTPClient = new HTTPClient();
